import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCheck } from '@ng-icons/lucide';
import { BrnSelect, BrnSelectOption } from '@spartan-ng/brain/select';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [{ directive: BrnSelectOption, inputs: ['disabled', 'value'] }],
  providers: [provideIcons({ lucideCheck })],
  host: {
    '[class]': '_computedClass()',
  },
  template: `
    @if (this._brnSelect.multiple()) {
      <span class="left-2 flex size-3.5 items-center justify-center">
        <hlm-checkbox [checked]="this._brnSelectOption.selected()" />
      </span>
    } @else {
      <span class="absolute right-2 flex size-3.5 items-center justify-center">
        @if (this._brnSelectOption.selected()) {
          <ng-icon hlm size="sm" aria-hidden="true" name="lucideCheck" />
        }
      </span>
    }
    <ng-content />
  `,
  imports: [HlmCheckboxImports, NgIcon],
})
export class HlmSelectOption {
  protected readonly _brnSelectOption = inject(BrnSelectOption, { host: true });
  protected readonly _brnSelect = inject(BrnSelect);
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm(
      'component-medium-medium hover:bg-components-background-primary-lightest min-h-xxl text-components-content-neutral-primary hover:text-components-content-neutral-primary [&>ng-icon]:!text-components-content-primary-main relative flex w-full cursor-default items-center gap-2 rounded-md py-xs pr-sm pl-xs component-medium-medium outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>ng-icon]:pointer-events-none [&>ng-icon]:shrink-0 [&>ng-icon]:size-md *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2',
      this.userClass(),
    ),
  );
}
